import { useEffect } from 'react';
import Storage from '../../../storage';
import UrlTo from '../../../url-to';
import { logError } from '../../../utilities/log';

const ProfileFromAppRedirect = ({ location, history }) => {
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const accessToken = query.get('accessToken');
    const refreshToken = query.get('refreshToken');

    if (!accessToken || !refreshToken) {
      logError('ProfileFromAppRedirect', 'Missing token', { accessToken: !!accessToken, refreshToken: !!refreshToken });
      history.replace(UrlTo.coursesHome());
      return;
    }

    Storage.authToken = accessToken;
    Storage.refreshToken = refreshToken;
    history.replace(UrlTo.coursesProfile());
  }, []);

  return null;
};

export default ProfileFromAppRedirect;
